
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".25","fill":"#E2E8F0"}},[_c('path',{attrs:{"d":"M65 80.365H35l-10 10h50l-10-10zM59.09 9.635l-.035.06-1.13 12.75L69.221 40.94 55.185 21.73l2.89-10.885-7.754 9.204 10.094 30.015-12.13-2.83 8.59 20.265L37.614 40l13.125.495-13.98-16.76 3.875-14.1H0v65.001h100V9.635H59.09z"}})])])
          )
        }
      }
    